import React from "react";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import AddItemBtn from "Common/Custom/AddItemBtn";
import RosterAssignedTable from "./Components/RosterAssignedTable";

const RosterAssignList = () => {
    return (
        <PageBody
            card={true}
            headerchildren={
                <>
                    <HeadingOne>Assigned Roster List</HeadingOne>
                    <div className="d-flex gap-2">
                        <AddItemBtn url="assign-employees" title="Assign Employee" />
                    </div>
                </>
            }>

            <RosterAssignedTable />

        </PageBody>
    );
};

export default RosterAssignList;